import { splitLocale } from '../../locale/localeUtils';
export const lineHeightTokens = () => {
  return 1.3;
};
export const lineHeightTokensNova = language => {
  // Split the locale into language, region, and script. Our font family designations contain different combinations of these aspects of the locale.
  const {
    lang
  } = splitLocale(language);
  switch (lang) {
    case 'ar':
    case 'zh':
    case 'ja':
    case 'ko':
    case 'th':
      return 1.5;
    default:
      return 1.4;
  }
};
//# sourceMappingURL=lineHeight.js.map